import { h } from 'preact';
import { VOID_FN } from '../../../../../utils';
import { UI_LAYER } from '../../../../common/constants';
import { useStyles } from '../../../../common/hooks';
import { LABEL_TEXT_FONT_SIZE } from '../../../../common/styles';
import { withBreakPoints } from '../../../hoc';
import { TOOLTIP_LAYER } from '../../../theme/constants';
import { Label } from '../../common';
import {
  TIMELINE_BUBBLE_LIVE_CONTENT_STYLE,
  TIMELINE_BUBBLE_LIVE_STYLE,
  TIMELINE_BUBBLE_SEEK_CONTENT_STYLE,
  TIMELINE_BUBBLE_SEEK_STYLE,
  TIMELINE_LIVE_STYLE_TOOLTIP,
  TIMELINE_POPUP_STYLE,
  TIMELINE_THUMBNAIL_STYLE,
  TOOLTIP_LABEL_STYLES
} from './styles';

export const TYPE_AUTO = 'auto';
export const TYPE_LIVE = 'live';
export const TYPE_DEFAULT = 'default';

function Tooltip({
  hidden,
  hover,
  isSliding,
  bubblePosition,
  thumbnail,
  dimensions,
  type = TYPE_DEFAULT,
  live,
  label,
  labelFn = (s) => s,
  onClick = VOID_FN,
  style = {},
  children,
  withBackgroundPosition = false,
  large,
  small,
  extraLarge,
  styleThumbnail = {},
  badge = null,
  styleBadge = {}
}) {
  const thumbnailStyle = {
    ...TIMELINE_THUMBNAIL_STYLE,
    ...{
      width: dimensions.thumbnail.width,
      height: dimensions.thumbnail.height
    },
    ...thumbnail?.url && {
      backgroundImage: `url('${thumbnail?.url}')`,
      // Defaults
      backgroundPosition: 'center',
      backgroundSize: 'cover',
      backgroundRepeat: 'no-repeat',
      border: '1px solid #fff',
      borderRadius: small ? 4 : 8
    },
    ...(withBackgroundPosition && {
      // Overrides for thumbnails in spritesheet
      backgroundPosition: `-${thumbnail?.x || 0}px -${thumbnail?.y || 0}px`,
      backgroundSize: 'initial',
      backgroundRepeat: 'initial'
    }),
    ...styleThumbnail
  };

  const dimensionsThumbnail = dimensions.thumbnail?.url ? {
    width: dimensions.thumbnail.width,
    height: dimensions.thumbnail.height
  } : {};

  const setStyles = useStyles();
  const { fontSize: bubbleFontSize } = setStyles(LABEL_TEXT_FONT_SIZE);
  const bubbleMapStyle = {
    [TYPE_DEFAULT]: {
      ...setStyles(TIMELINE_BUBBLE_SEEK_STYLE),
      width: dimensions.tooltip.width + 2,
      height: dimensions.tooltip.height,
      borderRadius: dimensions.tooltip.width,
      transform: 'translateY(-50%)',
      zIndex: UI_LAYER
    },
    [TYPE_LIVE]: {
      ...TIMELINE_BUBBLE_LIVE_STYLE,
      transform: 'translateY(calc(50%+12px))',
      transition: 'all 0.3s linear 0s',
      ...setStyles(TIMELINE_LIVE_STYLE_TOOLTIP)
    },

    [TYPE_AUTO]: {
      ...TIMELINE_BUBBLE_LIVE_STYLE,
      transition: 'all 0.3s linear 0s'
    }
  };

  const translateXNoImage = dimensions.thumbnail.width === 0 ? 'translateX(-50%)' : '';

  const wrapperStyle = {

    zIndex: TOOLTIP_LAYER,
    ...dimensionsThumbnail,
    ...TIMELINE_POPUP_STYLE,
    display: !hidden && (children || label) && (hover || isSliding || live) ? 'flex' : 'none',
    ...bubblePosition,
    ...style,
    ...(type !== TYPE_AUTO && thumbnail?.url && {
      ...{ transform: 'translateY(-90%)' },
      ...(large || extraLarge) && { transform: 'translateY(-105%)' }
    }),
    ...(type !== TYPE_AUTO && !thumbnail?.url && {
      transform: `${(large || extraLarge) ? 'translateY(calc(-96% - 6px))' : 'translateY(calc(-92% - 10px))'} ${translateXNoImage}`
    })
  };

  return (
    <div
      role="presentation"
      style={wrapperStyle}
      onClick={(e) => { e.stopPropagation(); onClick(); }}
    >
      {badge && (
        <Label
          message={badge}
          style={styleBadge}
          styleText={setStyles(TOOLTIP_LABEL_STYLES)}
        />
      )}
      <div style={{ ...thumbnailStyle }} />
      <div
        style={{
          ...bubbleMapStyle[type],
          fontSize: bubbleFontSize,
          ...(TYPE_LIVE === type ? setStyles(TIMELINE_BUBBLE_LIVE_CONTENT_STYLE) : TIMELINE_BUBBLE_SEEK_CONTENT_STYLE),
          display: 'flex', flexDirection: 'column'
        }}
      >
        {children || labelFn(label)}
      </div>
    </div>
  );
}

export default withBreakPoints(Tooltip);
